<template>
  <div>
    <div v-for="(item, index) in formList" :key="index">
      <div v-if="item.formField">
        <!-- 描述 -->
        <div class="info" v-if="item.formField.fieldName == '描述' && !item.formField.type">
          <div class="info_key">
            <div
              style="color: #ff4d42;width:11px"
            >
              <span v-if="item.formField.createFlage == '1'">*</span>
            </div>
            <i class="iconfont icon-describe info_icon" style="font-size: 14px" />
            <el-tooltip
              effect="dark"
              content="描述"
              placement="bottom"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <div>描述</div>
            </el-tooltip>
          </div>
          <div style="width: 85%; margin-top: 5px">
            <Describe :describes="describes" @func="addtask" :formdetail="formdetail" />
          </div>
        </div>
        <!-- 标签 -->
        <div class="info" v-else-if="item.formField.fieldName == '标签' && !item.formField.type">
          <div class="info_key">
            <div
              style="color: #ff4d42;width:11px"
            >
              <span v-if="item.formField.createFlage == '1'">*</span>
            </div>
            <i class="iconfont icon-tag info_icon" />
            <el-tooltip
              effect="dark"
              content="标签"
              placement="bottom"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <div>标签</div>
            </el-tooltip>
          </div>
          <div class="info_value">
            <div class="info_box">
              <div
                class="info_tags"
                v-for="(tag, index1) in dialogCreat.labelList"
                :key="index1"
                v-show="dialogCreat.labelList && dialogCreat.labelList.length > 0"
              >
                <el-tag
                  style="margin-right: 16px"
                  :style="
                    'color:' +
                      tag.color +
                      ';background:' +
                      convertHex(tag.color, 10)
                  "
                  type="warning"
                >{{tag.labelName}}</el-tag>
                <i
                  class="iconfont icon-shanchu del_icon"
                  @click="delTagsChange(tag)"
                />
              </div>
              <el-popover placement="bottom" width="540" trigger="click">
                <TagsList :tags-objects="tagsObject" :tag-lists="tagList" />
                <i
                  class="iconfont icon-jiahao2fill add_icon"
                  slot="reference"
                  :style="
                    item.labelList && item.labelList.length > 0
                      ? 'margin: 0 10px;line-height: 30px;'
                      : 'margin: 0;line-height: 30px;'
                  "
                />
              </el-popover>
            </div>
          </div>
        </div>
        <!-- 自定义字段 -->
        <div class="info" v-else>
          <div class="info_key">
            <div style="color: #ff4d42;width:11px">
              <span v-if="item.formField.createFlage == '1'">*</span>
            </div>
            <i
              class="iconfont info_icon"
              :class="getIconClass(item.type)"
            />
            <el-tooltip
              effect="dark"
              :content="item.formField.fieldName"
              placement="bottom"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <div class="form_fieldName">{{item.formField.fieldName}}</div>
            </el-tooltip>
          </div>
          <!-- 输入框 -->
          <div class="info_value" v-if="item.formField.type == '0' || item.formField.type == '1'">
            <div
              style="width:100%"
            >
              <!-- 输入框 文本 -->
              <div v-if="item.formField.type == '0'">
                <el-input
                  :ref="item.id"
                  :autofocus="true"
                  v-model="item.fieldValue"
                  placeholder="点击添加"
                  @change="addFormData"
                />
              </div>
              <!-- 输入框 数字 -->
              <div v-if="item.formField.type == '1'">
                <el-input
                  :ref="item.id"
                  type="number"
                  :autofocus="true"
                  v-model="item.fieldValue"
                  oninput="if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                  @input="numValue(item)"
                  @change="addFormData"
                />
              </div>
            </div>
          </div>
          <!-- 富文本 -->
          <div class="info_value" v-else-if="item.formField.type == '2'">
            <div
              style="width:100%"
            >
              <Describe :describes="item.describes" :formdetail="formdetail" :form-data="item" @func="addDescs" />
            </div>
          </div>
          <!-- 附件钉钉上传文件 -->
          <div
            class=" info_value"
            v-else-if="uploadType === 'ding' &&item.formField.type == '3'"
          >
            <div style="width: 100%">
              <!-- 钉钉上传文件 -->
              <div
                @click="uploadFile(item)"
                class="uploadfile"
                style="width: calc(100% - 11px);margin-left:11px"
              >
                <i class="iconfont icon-a-02beifen2 file_icon" />
                <span class="test">附件</span>
              </div>
              <div class="file_lists" v-if="item.files&&item.files.length > 0">
                <div class="file_boxs" v-for="(file, index_file) in item.files" :key="index_file">
                  <div class="file_text" @click.stop="previewFile(file)">
                    <i class="iconfont icon-wenjian file__icon" />
                    <span>{{file.fileName}}</span>
                  </div>
                  <i
                    class="iconfont icon-shanchu1 del__icon"
                    @click="delFunFile(file, index_file, item)"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 企微上传文件 -->
          <div
            class=" info_value"
            v-else-if="uploadType === 'oss' && item.formField.type == '3'"
          >
            <div style="width: 100%">
              <div
                class="uploadfile"
                style="width: calc(100% - 11px);margin-left:11px"
              >
                <multi-upload
                  :file-data="{objectType: '1',objectId: '',type: '15',taskId: '',proId: proId,source: 'oss',versionId: '', fieldId: item.formField.id}"
                  @setFileList="successFile"
                  :upload-btn="uploadBtn"
                />
              </div>
              <div class="file_lists" v-if="item.files&&item.files.length > 0">
                <div class="file_boxs" v-for="(file, index_file) in item.files" :key="index_file">
                  <div class="file_text" @click.stop="previewFile(file)">
                    <i class="iconfont icon-wenjian file__icon" />
                    <span>{{file.fileName}}</span>
                  </div>
                  <i
                    class="iconfont icon-shanchu1 del__icon"
                    @click="delFunFile(file, index_file, item)"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 时间 -->
          <div class="info_value" v-else-if="item.formField.type == '4'">
            <div>
              <el-date-picker
                :ref="item.id"
                v-model="item.fieldValue"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy/MM/dd HH:mm:ss"
                format="yyyy/MM/dd HH:mm:ss"
                @change="addFormData"
              />
            </div>
          </div>
          <!-- 位置 -->
          <div class="info_value" v-else-if="item.formField.type == '5'">
            <div
              class="info_value_text"
            >
              <span>{{item.addressName}}</span>
              <el-tooltip
                effect="dark"
                content="PC端不支持位置功能，请在手机端选择！"
                placement="bottom"
                popper-class="texttooltip"
                :open-delay="500"
              >
                <i class="iconfont icon-bianzu info_icon" :style="item.addressName?'margin-left:5px':''" />
              </el-tooltip>
            </div>
          </div>
          <!-- 拍照 -->
          <div class="info_value" v-else-if="item.formField.type == '17'">
            <div
              class="info_value_text"
            >
              <div class="file_lists" v-if="item.files&&item.files.length > 0">
                <div class="file_boxs" v-for="(fileItem, index_file) in item.files" :key="index_file">
                  <div class="file_text" @click.stop="previewFile(file)">
                    <i class="iconfont icon-wenjian file__icon" />
                    <span>{{fileItem.fileName}}</span>
                  </div>
                  <i
                    class="iconfont icon-shanchu1 del__icon"
                    @click="delFunFile(fileItem, index_file, item)"
                  />
                </div>
              </div>
              <el-tooltip
                v-else
                effect="dark"
                content="PC端不支持拍照功能，请在手机端进行拍照！"
                placement="bottom"
                popper-class="texttooltip"
                :open-delay="500"
              >
                <i class="iconfont icon-xiangji1 info_icon" />
              </el-tooltip>
            </div>
          </div>
          <!-- 单选 -->
          <div class="info_value" v-else-if="item.formField.type == '6'">
            <div
              style="width: calc(100% - 11px);padding-left:11px"
            >
              <el-radio-group v-model="item.fieldValue" @change="addFormData">
                <el-radio
                  v-for="key in item.formField.optionsArray"
                  :key="key.key"
                  :label="key.key"
                >{{key.value}}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- 多选 -->
          <div class="info_value" v-else-if="item.formField.type == '7'">
            <div
              style="width: calc(100% - 11px);padding-left:11px"
            >
              <el-checkbox-group v-model="item.strArray" @change="checkboxChange1(index, item.strArray)">
                <el-checkbox
                  v-for="key in item.formField.optionsArray"
                  :key="key.key"
                  :label="key.key"
                >{{key.value}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <!-- 下拉单选 -->
          <div
            class="info_value"
            v-else-if="item.formField.type == '8'"
          >
            <div
              style="width:100%"
            >
              <el-select
                :ref="item.id"
                v-model="item.fieldValue"
                filterable
                placeholder="请选择内容"
                @change="addFormData"
                style="width:100%"
              >
                <el-option
                  v-for="key in item.formField.optionsArray"
                  :key="key.key"
                  :label="key.value"
                  :value="key.key"
                />
              </el-select>
            </div>
          </div>
          <!-- 下拉多选 -->
          <div
            class="info_value"
            v-else-if="item.formField.type == '9'"
          >
            <div
              style="width:100%"
            >
              <el-select
                :ref="item.id"
                v-model="item.strArray"
                filterable
                placeholder="请选择内容"
                multiple
                collapse-tags
                style="width:100%"
                @change="checkboxChange1(index, item.strArray)"
              >
                <el-option
                  v-for="key in item.formField.optionsArray"
                  :key="key.key"
                  :label="key.value"
                  :value="key.key"
                />
              </el-select>
            </div>
          </div>
          <!-- 人员 -->
          <div
            class="info_value"
            v-else-if="item.formField.type == '10' || item.formField.type == '11'"
          >
            <div
              class="personnel"
            >
              <div
                style="width: 100%; display: flex; align-items: flex-start"
              >
                <draggable
                  v-model="item.users"
                  group="responseUsers"
                  :options="{ handle: '.info_personnel1' }"
                  :style="creatType === 'waixie' ? '' : 'max-width: calc(100% - 45px)'"
                  animation="500"
                >
                  <transition-group style="display: flex; flex-wrap: wrap">
                    <div
                      style="margin-left: 11px;"
                      v-for="(user, index2) in item.users"
                      :key="index2"
                    >
                      <!-- @click="contactCh(item.users, index, item.formField.type)" -->
                      <div class="user_personnel" v-if=" channel === 'wechat'">
                        <div class="info_personnel1">
                          <img
                            v-if="user.avatar != ''&& user.avatar != null"
                            class="info_personnel_surname1"
                            :src="user.avatar"
                          >
                          <div>
                            <ww-open-data type="userName" :openid="user.name" />
                          </div>
                        </div>
                        <i
                          class="iconfont icon-shanchu del_icon"
                          @click.stop="delUsers(item.users, index2, index)"
                        />
                      </div>
                      <div class="user_personnel" v-else>
                        <div class="info_personnel1">
                          <img
                            v-if="user.avatar != '' && user.avatar != null"
                            class="info_personnel_surname1"
                            :src="user.avatar"
                          >
                          <div v-else class="info_personnel_surname1">
                            {{user.name.substring(0, 1)}}
                          </div>
                          <div>{{user.name}}</div>
                        </div>
                        <i
                          class="iconfont icon-shanchu del_icon"
                          @click.stop="delUsers(item.users, index2, index)"
                        />
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <div>
                  <candidate
                    v-if="creatType === 'waixie'"
                    :is-multiple="item.formField.type == '10' ? false : true"
                    :is-show-icon="true"
                    :setect-user="item.users"
                    @getSetectUser="(val) => setupTaskFollow(val, index, item.formField.type)"
                  />
                  <i
                    v-else
                    class="iconfont icon-jiahao2fill add_icon"
                    @click.stop="contactCh(item.users, index, item.formField.type)"
                    style="margin: 0 24px"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 其他类型 -->
          <div class="info_value" v-else>
            <div style="width:100%">
              <el-input
                :ref="item.id"
                :autofocus="true"
                v-model="item.fieldValue"
                placeholder="点击添加"
                @change="addFormData"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- 描述 -->
        <div class="info" v-if="item.fieldName == '描述' && !item.type">
          <div class="info_key">
            <div
              style="color: #ff4d42;width:11px"
            >
              <span v-if="item.createFlage == '1'">*</span>
            </div>
            <i class="iconfont icon-describe info_icon" style="font-size: 14px" />
            <el-tooltip
              effect="dark"
              content="描述"
              placement="bottom"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <div>描述</div>
            </el-tooltip>
          </div>
          <div style="width: 85%; margin-top: 5px">
            <Describe :describes="describes" @func="addtask" />
          </div>
        </div>
        <!-- 标签 -->
        <div class="info" v-else-if="item.fieldName == '标签' && !item.type">
          <div class="info_key">
            <div
              style="color: #ff4d42;width:11px"
            >
              <span v-if="item.createFlage == '1'">*</span>
            </div>
            <i class="iconfont icon-tag info_icon" />
            <el-tooltip
              effect="dark"
              content="标签"
              placement="bottom"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <div>标签</div>
            </el-tooltip>
          </div>
          <div class="info_value">
            <div class="info_box">
              <div
                class="info_tags"
                v-for="(tag, index1) in dialogCreat.labelList"
                :key="index1"
                v-show="dialogCreat.labelList && dialogCreat.labelList.length > 0"
              >
                <el-tag
                  style="margin-right: 16px"
                  :style="
                    'color:' +
                      tag.color +
                      ';background:' +
                      convertHex(tag.color, 10)
                  "
                  type="warning"
                >{{tag.labelName}}</el-tag>
                <i
                  class="iconfont icon-shanchu del_icon"
                  @click="delTagsChange(tag)"
                />
              </div>
              <el-popover placement="bottom" width="540" trigger="click">
                <TagsList :tags-objects="tagsObject" :tag-lists="tagList" />
                <i
                  class="iconfont icon-jiahao2fill add_icon"
                  slot="reference"
                  :style="
                    item.labelList && item.labelList.length > 0
                      ? 'margin: 0 10px;line-height: 30px;'
                      : 'margin: 0;line-height: 30px;'
                  "
                />
              </el-popover>
            </div>
          </div>
        </div>
        <!-- 自定义字段 -->
        <div class="info" v-else>
          <div class="info_key">
            <div
              style="color: #ff4d42;width:11px"
            >
              <span v-if="item.createFlage == '1'">*</span>
            </div>
            <i
              class="iconfont info_icon"
              :class="getIconClass(item.type)"
            />
            <el-tooltip
              effect="dark"
              :content="item.fieldName"
              placement="bottom"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <div class="form_fieldName">{{item.fieldName}}</div>
            </el-tooltip>
          </div>
          <!-- 输入框 文本 -->
          <div class="info_value" v-if="item.type == '0'">
            <el-input
              ref="input_name"
              :autofocus="true"
              v-model="item.fieldValue"
              placeholder="点击添加"
              @change="addFormData"
            />
          </div>
          <!-- 输入框 数字 -->
          <div class="info_value" v-else-if="item.type == '1'">
            <el-input
              ref="input_name"
              type="'number'"
              :autofocus="true"
              v-model="item.fieldValue"
              placeholder="点击添加"
              @input="numValue(item)"
              oninput="if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              @change="addFormData"
            />
          </div>
          <!-- 富文本 -->
          <div class="info_value" v-else-if="item.type == '2'">
            <Describe :describes="item.describes" @func="addDescs" />
          </div>
          <!-- 附件 -->
          <div class="info_value" v-else-if="item.type == '3' && uploadType === 'ding'">
            <div style="width: 100%;">
              <div @click="uploadFile(item)" class="uploadfile">
                <i class="iconfont icon-a-02beifen2 file_icon" />
                <span class="test">附件</span>
              </div>
              <div class="file_lists" v-if="item.fileList&&item.fileList.length > 0">
                <div class="file_boxs" v-for="(file, index_file) in item.fileList" :key="index_file" @click="previewFile(file)">
                  <div class="file_text">
                    <i class="iconfont icon-wenjian file__icon" />
                    <span>{{file.fileName}}</span>
                  </div>
                  <i class="iconfont icon-shanchu1 del__icon" @click.stop="delFun(file, index_file, item)" />
                </div>
              </div>
            </div>
          </div>
          <div class="info_value" v-else-if="item.type == '3' && uploadType === 'oss'">
            <div style="width: 100%;">
              <div class="uploadfile">
                <multi-upload
                  :file-data="{objectType: '1',objectId: '',type: '15',proId: proId,source: 'oss',versionId: '', fieldId: item.id}"
                  @setFileList="successFile"
                  :upload-btn="uploadBtn"
                />
              </div>
              <div class="file_lists" v-if="item.fileList&&item.fileList.length > 0">
                <div class="file_boxs" v-for="(file, index_file) in item.fileList" :key="index_file" @click="previewFile(file)">
                  <div class="file_text">
                    <i class="iconfont icon-wenjian file__icon" />
                    <span>{{file.fileName}}</span>
                  </div>
                  <i class="iconfont icon-shanchu1 del__icon" @click.stop="delFun(file, index_file, item)" />
                </div>
              </div>
            </div>
          </div>
          <!-- 时间 -->
          <div class="info_value" v-else-if="item.type == '4'">
            <el-date-picker
              v-model="item.fieldValue"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy/MM/dd HH:mm:ss"
              format="yyyy/MM/dd HH:mm:ss"
              @change="addFormData"
            />
          </div>
          <!-- 位置 -->
          <div class="info_value" v-else-if="item.type == '5'">
            <el-tooltip
              effect="dark"
              content="PC端不支持位置功能，请在手机端选择！"
              placement="top"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <i class="iconfont icon-bianzu info_icon" />
            </el-tooltip>
          </div>
          <!-- 拍照 -->
          <div class="info_value" v-else-if="item.type == '17'">
            <el-tooltip
              effect="dark"
              content="PC端不支持拍照功能，请在手机端进行拍照！"
              placement="top"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <i class="iconfont icon-xiangji1 info_icon" />
            </el-tooltip>
          </div>
          <!-- 单选 -->
          <div class="info_value" v-else-if="item.type == '6'">
            <el-radio-group v-model="item.fieldValue" @change="addFormData">
              <el-radio
                v-for="key in item.optionsArray"
                :key="key.key"
                :label="key.key"
              >{{key.value}}</el-radio>
            </el-radio-group>
          </div>
          <!-- 多选 -->
          <div class="info_value" v-else-if="item.type == '7'">
            <el-checkbox-group v-model="item.fieldValue" @change="checkboxChange">
              <el-checkbox
                v-for="key in item.optionsArray"
                :key="key.key"
                :label="key.key"
              >{{key.value}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <!-- 下拉选择 -->
          <div
            class="info_value"
            v-else-if="item.type == '8' || item.type == '9'"
          >
            <el-select
              v-model="item.fieldValue"
              filterable
              placeholder="请选择内容"
              :multiple="item.type == '9'"
              collapse-tags
              @change="addFormData"
              style="width:100%"
            >
              <el-option
                v-for="key in item.optionsArray"
                :key="key.key"
                :label="key.value"
                :value="key.key"
              />
            </el-select>
          </div>
          <!-- 人员 -->
          <div
            class="info_value"
            v-else-if="item.type == '10' || item.type == '11'"
          >
            <div
              class="personnel"
              style="width: 83%; display: flex; align-items: flex-start"
            >
              <draggable
                v-model="item.userList"
                group="userList"
                :options="{ handle: '.info_personnel1' }"
                animation="500"
              >
                <transition-group style="display: flex; flex-wrap: wrap">
                  <div
                    class="user_personnel"
                    v-for="(user, index2) in item.userList"
                    :key="index2"
                  >
                    <!-- @click="contactCh(item.userList, index, item.type)" -->
                    <div class="info_personnel1" v-if="channel === 'wechat'">
                      <img
                        v-if="user.avatar != '' && user.avatar != null"
                        class="info_personnel_surname1"
                        :src="user.avatar"
                      >
                      <div>
                        <ww-open-data type="userName" :openid="user.name" />
                      </div>
                    </div>
                    <div class="info_personnel1" v-else>
                      <img
                        v-if="user.avatar != ''&& user.avatar != null"
                        class="info_personnel_surname1"
                        :src="user.avatar"
                      >
                      <div v-else class="info_personnel_surname1">
                        {{user.name.substring(0, 1)}}
                      </div>
                      <div>{{user.name}}</div>
                    </div>
                    <i
                      class="iconfont icon-shanchu del_icon"
                      @click.stop="delUsers(item.userList, index2, index)"
                    />
                  </div>
                </transition-group>
              </draggable>
              <div>
                <candidate
                  v-if="creatType === 'waixie'"
                  :is-multiple="item.type == '10' ? false : true"
                  :is-show-icon="true"
                  :setect-user="item.userList"
                  @getSetectUser="(val) => setupTaskFollow(val, index, item.type)"
                />
                <i
                  v-else
                  class="iconfont icon-jiahao2fill add_icon"
                  @click.stop="contactCh(item.userList, index, item.type)"
                  style="margin: 0 24px"
                />
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div class="pop_table" v-else-if="item.type == '18'">
            <div>
              <el-button type="primary" plain @click.stop="addRow(item.value.dataList, '', '', 'bot')">
                <i class="iconfont icon-jiahao1 creat-icon" style="font-size:15px;color:#fff" />
                新增
              </el-button>
              <!-- <el-button plain>
                <i class="iconfont icon-daoru creat-icon" style="font-size:15px;" />
                导入
              </el-button> -->
            </div>
            <el-table
              class="scpc-task-table"
              :data="item.value.dataList && item.value.dataList.length > 0 ? item.value.dataList : [{}]"
              :header-cell-style="{
                background: '#F1F1F1 ',
                fontSize: '14px',
                color: '#999999',
              }"
              :cell-style="{
                fontSize: '14px'
              }"
              height="100%"
              border
              ref="table"
            >
              <div slot="empty" class="empty" style="display: none;">
                暂无数据
              </div>
              <el-table-column type="index" />
              <template>
                <el-table-column
                  v-for="(itemTab, index3) in item.value.headList"
                  :key="index3"
                  :prop="itemTab.fieldName"
                  min-width="200"
                >
                  <!-- 表头 -->
                  <template v-slot:header>
                    <div style="position: relative;">
                      <span>{{itemTab.fieldName}} </span>
                      <i class="iconfont icon-bitian" style="cursor: pointer;color: #FF4D42;position: absolute;top: -5px;" v-show="itemTab.required === '1'" />
                    </div>
                  </template>
                  <!-- 内容 -->
                  <template slot-scope="scope">
                    <div v-if="itemTab.type === '0'">
                      <el-input
                        type="textarea"
                        autosize
                        placeholder="请输入0"
                        v-model="scope.row.value"
                      />
                    </div>
                    <div v-if="itemTab.type === '1'">
                      <el-input
                        type="textarea"
                        autosize
                        placeholder="请输入1"
                        v-model="scope.row.value"
                      />
                    </div>
                  </template>
                </el-table-column>
              </template>
              <el-table-column prop="operation" label="操作" width="100px" fixed="right">
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    width="100"
                    trigger="click"
                    ref="popInventory"
                  >
                    <div>
                      <div class="pop_item" @click.stop="copyRow(item.value.dataList, scope.row, scope.$index)">复制</div>
                      <div class="pop_item" @click.stop="clearRow(item.value.dataList, scope.row, scope.$index)">清空行数据</div>
                      <div class="pop_item" @click.stop="addRow(item.value.dataList, scope.row, scope.$index, 'top')">在上面添加行</div>
                      <div class="pop_item" @click.stop="addRow(item.value.dataList, scope.row, scope.$index, 'bot')">在下面面添加行</div>
                      <div class="pop_item" @click.stop="deleteRow(item.value.dataList, scope.row, scope.$index)" v-if="item.value.dataList && item.value.dataList.length > 1">删除</div>
                    </div>
                    <span slot="reference">
                      <i
                        class="iconfont icon-gengduo3 form_name_icon"
                        style="cursor: pointer;font-size: 19px;"
                      />
                    </span>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 其他类型 -->
          <div class="info_value" v-else>
            <el-input
              ref="input_name"
              :autofocus="true"
              v-model="item.fieldValue"
              placeholder="点击添加"
              @change="addFormData"
            />
          </div>
        </div>
      </div>
      <!-- 视频预览组件 -->
      <VideoPreview
        :visible.sync="showVideo"
        :url="videoUrl"
        @update:visible="val => console.log('visible 更新为:', val)"
      />
    </div>
  </div>
</template>

<script>
import candidate from './candidate.vue'
import Describe from './describe.vue'
import draggable from 'vuedraggable'
import TagsList from './tagsList.vue'
import { findLabelList, getShowAuthority } from '../../utils/api/task'
import { findUserIds } from '../../utils/api/user.js' // , addDingFile
import { delChange, editChange } from '../../utils/tag.js'
import choose from 'dingtalk-jsapi/api/biz/contact/choose' // PC 通讯录选人
import Vue from 'vue'
import { delFile, initIsvDingSpace, addDingFile, initPreviewAuth } from '../../utils/api/file'
import uploadAttachment from 'dingtalk-jsapi/api/biz/util/uploadAttachment' // 上传附件到钉盘/从钉盘选择文件
import preview from 'dingtalk-jsapi/api/biz/cspace/preview' // 预览文件
import { wpsOfficeConfig } from '../../utils/wpsoffice/wpsOffice'
import multiUpload from './upload/multiUpload.vue'
import VideoPreview from './videoPreview/index.vue'
export default {
  components: {
    Describe,
    TagsList,
    draggable,
    multiUpload,
    candidate,
    VideoPreview
  },
  props: {
    formJson: {
      type: Array,
      default: () => []
    },
    proId: {
      type: String,
      default: () => ''
    },
    formdetail: {
      type: Object,
      default: () => {}
    },
    creatType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      headers: {
        sessiontoken: JSON.parse(sessionStorage.getItem('loginUserData')).sessionTokenId
      },
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      uploadType: JSON.parse(sessionStorage.getItem('loginUserData')).uploadType,
      tryOutType: JSON.parse(sessionStorage.getItem('loginUserData')).tryOutType,
      formList: [],
      dialogCreat: {
        labelList: [] // 标签
      },
      // 描述
      describes: {
        describe: '',
        maxlength_show: true,
        descList: [],
        editTaskChange: this.editTaskChange,
        objectType: '1',
        proId: '',
        type: '0',
        appendType: '2'
      },
      // 标签列表
      tagList: [],
      tagsObject: {
        checkboxGroup: [],
        fun: this.checkboxGroupChange
      },
      type: 'process',
      uploadBtn: 'desc',
      file: [],
      showVideo: false,
      videoUrl: ''
    }
  },
  watch: {
    formJson: {
      handler() {
        this.dataJson()
      }
      // deep: true
    }
  },
  mounted() {
    this.dataJson()
  },
  methods: {
    closePop() {
      if (this.$refs.popInventory) {
        if (Array.isArray(this.$refs.popInventory)) {
          this.$refs.popInventory.forEach(pop => {
            if (pop && typeof pop.doClose === 'function') {
              pop.doClose()
            }
          })
        } else if (this.$refs.popInventory && typeof this.$refs.popInventory.doClose === 'function') {
          this.$refs.popInventory.doClose()
        }
      }
    },

    // 复制行 - 修改后第一次点击就会生效
    copyRow(dataList, row, index) {
      console.log(dataList, 'dataList')
      const newRow = JSON.parse(JSON.stringify(row))
      dataList.splice(index + 1, 0, newRow) // 在当前行后面插入复制的行
      this.closePop()
    },

    // 添加行 - 更清晰的逻辑
    addRow(dataList, row, index, position) {
      const newRow = {}
      Object.keys(row).forEach(key => {
        newRow[key] = ''
      })

      if (position === 'top') {
        dataList.splice(index, 0, newRow) // 在当前行前面添加
      } else if (position === 'bot') {
        dataList.splice(index + 1, 0, newRow) // 在当前行后面添加
      }
      this.closePop()
    },

    // 清空行数据
    clearRow(dataList, row, index) {
      Object.keys(row).forEach(key => {
        row[key] = ''
      })
      this.closePop()
    },

    // 删除行
    deleteRow(dataList, row, index) {
      dataList.splice(index, 1)
      this.closePop()
    },
    getIconClass(type) {
      const classMap = {
        '0': 'icon-a-01',
        '1': 'icon-a-02beifen',
        '2': 'icon-a-02',
        '3': 'icon-a-02beifen2',
        '4': 'icon-a-02beifen3',
        '5': 'icon-bianzu',
        '6': 'icon-danxuan',
        '7': 'icon-a-02beifen5',
        '8': 'icon-a-02beifen7',
        '9': 'icon-a-02beifen8',
        '10': 'icon-a-02beifen9',
        '11': 'icon-a-02beifen10',
        '17': 'icon-xiangji1',
        '18': 'icon-biaoge1'
      }
      return classMap[type] || 'icon-wenbenkuang'
    },
    // 文件上传之前的校验
    beforeUpload(file) {
      // this.$refs.upload.clearFiles()
      this.$refs.upload[0].data.fileFormat = file.name.split('.').pop()
      this.$refs.upload[0].data.fileName = file.name
      this.$refs.upload[0].data.fileSize = file.size
    },
    // 文件上传成功
    successFile(response, file, fileList, fieldId) {
      if (response.code === 10000) {
        this.formList.map((item) => {
          // if (item.type === '3') {
          if (item.formField) {
            if (item.formField.type === '3' && item.formField.id === fieldId) {
              item.files.push(response.result)
            }
          } else {
            if (item.type === '3' && item.id === fieldId) {
              item.fileList.push(response.result)
            }
          }
          this.addFormData()
          // }
        })
      } else {
        this.$message.warning(response.info)
      }
    },
    // 数据源
    dataJson() {
      this.formList = this.formJson
      this.dialogCreat.labelList = [] // 标签
      if (this.formdetail && (this.formdetail.remark || (this.formdetail.fileList && this.formdetail.fileList.length > 0))) {
        this.describes.describe = this.formdetail.remark
        this.describes.descList = this.formdetail.fileList
      }
      this.getTabsList()
    },
    // 钉钉通讯录选人组件
    contactChoose(userids, index, type) {
      // alert('userids ' + JSON.stringify(userids))
      var that = this
      var multiple = true
      if (type === '10') {
        multiple = false
      }
      choose({
        multiple: multiple, // 是否多选：true多选 false单选； 默认true
        users: userids, // 默认选中的用户列表，员工userid；成功回调中应包含该信息
        corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId, // 企业id
        max: 100, // 人数限制，当multiple为true才生效，可选范围1-1500
        // emplId 员工ID
        onSuccess: function(res) {
          if (res.length > 0) {
            var date = {
              users: res
            }
            // alert('数据 ' + JSON.stringify(date))
            findUserIds(date)
              .then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.setupTaskFollow(res1.result.userList, index)
                } else {
                  this.$message.warning(
                    res1.result.unAuthUserNameList.join(',') + ' 未授权'
                  )
                }
              })
              .catch((error) => {
                console.log('error111', error)
                //  this.$message.error('网络错误，请稍候！')
              })
          }
        },
        onFail: function(err) {
          console.log('err111', err)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        }
      })
        .then((res) => {
          console.log('then______err', res)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
        .catch((err) => {
          console.log('catch______err', err)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
    },
    // 企微通讯录选人组件
    wechatLogin(userids, index, type) {
      var that = this
      var multiple = 'multi'
      if (type === '10') {
        multiple = 'single'
      }
      if (this.tryOutType === '1') {
        Vue.prototype.$wx.invoke('selectPrivilegedContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': multiple, // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectPrivilegedContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList || [] // 已选的成员列表
            const selectedTicket = res.result.selectedTicket || '' // 已选的成员Ticket列表
            if (selectedUserList.length > 0 || selectedTicket.length > 0) {
              var date = {
                type: 'user',
                users: selectedUserList,
                ticket: selectedTicket
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.setupTaskFollow(res1.result.userList, index)
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      } else {
        Vue.prototype.$wx.invoke('selectEnterpriseContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': multiple, // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectEnterpriseContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList // 已选的成员列表
            if (selectedUserList.length > 0) {
              var date = {
                users: selectedUserList
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.setupTaskFollow(res1.result.userList, index)
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      }
    },
    // 编辑人员
    setupTaskFollow(res, index) {
      // alert('数据 ' + JSON.stringify(res), index)
      this.formList[index].userList = res
      this.formList[index].users = res
      this.$forceUpdate() // 强制更新视图
      this.addFormData()
    },
    // 添加人员
    contactCh(principalUsers, index, type) {
      if (!principalUsers) {
        principalUsers = []
      }
      var userids = []
      principalUsers.map((item) => {
        userids.push(item.userid)
      })
      if (this.channel === 'ding') {
        this.contactChoose(userids, index, type)
      } else if (this.channel === 'wechat') {
        this.wechatLogin(userids, index, type)
      }
    },
    // 删除人员
    delUsers(principalUsers, index2, index) {
      principalUsers.splice(index2, 1)
      this.setupTaskFollow(principalUsers, index)
    },
    // 描述
    addtask(result) {
      this.describes.descList = result
      this.addFormData()
    },
    // 标签透明度
    convertHex(hex, opacity) {
      hex = hex?.replace('#', '')
      var r = parseInt(hex?.substring(0, 2), 16)
      var g = parseInt(hex?.substring(2, 4), 16)
      var b = parseInt(hex?.substring(4, 6), 16)
      var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
      return result
    },
    // 编辑任务标签
    checkboxGroupChange() {
      this.dialogCreat.labelList = editChange(
        this.tagList,
        this.tagsObject.checkboxGroup
      )
      this.addFormData()
    },
    // 删除任务标签
    delTagsChange(tag) {
      this.tagsObject.checkboxGroup.splice(
        delChange(tag, this.tagsObject.checkboxGroup),
        1
      )
      this.checkboxGroupChange()
    },
    // 任务标签列表
    getTabsList() {
      findLabelList()
        .then((data) => {
          if (data.code === 10000) {
            this.tagList = data.result
            if (this.formdetail && this.formdetail.followLabels && this.formdetail.followLabels.length > 0) {
              var checkboxGroup = []
              this.dialogCreat.labelList = this.formdetail.followLabels
              this.formdetail.followLabels.map((item) => {
                checkboxGroup.push(item.id)
              })
              this.tagsObject.checkboxGroup = checkboxGroup
            } else {
              this.dialogCreat.labelList = []
              this.tagsObject.checkboxGroup = []
            }
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 数值校验
    numValue(item) {
      // 修复第一个字符是小数点 的情况.
      if (item.fieldValue !== '' && item.fieldValue.substr(0, 1) === '.') {
        item.fieldValue = ''
      }
      item.fieldValue = item.fieldValue.replace(/^0*(0\.|[1-9])/, '$1') // 解决 粘贴不生效
      // item.fieldValue = item.fieldValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      // item.fieldValue = item.fieldValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      item.fieldValue = item.fieldValue.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      item.fieldValue = item.fieldValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
      item.fieldValue = item.fieldValue.replace(/[^\-\d.]/g, '') // 只能输入.和-和数字
      item.fieldValue = item.fieldValue.replace(/^\./g, '') // 第一个字符不能是.
      item.fieldValue = item.fieldValue.replace(/\.{2,}/g, '.') // 不能连续输入.
      item.fieldValue = item.fieldValue.replace(/(\.\d+)\./g, '$1') // .后面不能再输入.
      item.fieldValue = item.fieldValue.replace(/(-)\./g, '$1') // -后面不能输入.
      item.fieldValue = item.fieldValue.replace(/\-{2,}/g, '-') // -只能保留一个
      item.fieldValue = item.fieldValue.replace(/(\d+|\.)-/g, '$1') // 数字和.后面不能接-,不能出现类似11-, 12.-
      item.fieldValue = item.fieldValue.replace(/-(0){2,}/g, '$1') // 不能出现-00,-001,-0001类似
      item.fieldValue = item.fieldValue.replace(/(-)0+(\d+)/g, '$1$2') // 不能出现-01,-02类似
      item.fieldValue = item.fieldValue.replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      if (item.fieldValue.indexOf('.') < 0 && item.fieldValue !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        if (item.fieldValue.substr(0, 1) === '0' && item.fieldValue.length === 2) {
          item.fieldValue = item.fieldValue.substr(1, item.fieldValue.length)
        }
      }
    },
    // 添加文件
    uploadFile(item) {
      var that = this
      var date = {
        authType: 'add',
        objectType: '2',
        objectId: ''
      }
      initIsvDingSpace(date).then((res) => {
        uploadAttachment({
          file: {
            multiple: true,
            spaceId: res.result + '',
            max: 9
          },
          space: {
            corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
            spaceId: res.result + '',
            isCopy: 1,
            max: 9
          },
          image: {
            multiple: true,
            compress: true,
            max: 9,
            spaceId: res.result + ''
          },
          types: [
            'space',
            'file',
            'photo'], // PC端支持["photo","file","space"]
          onSuccess: function(result) {
            var list = []
            if (!result.data) {
              list = result || []
            } else {
              list = result.data || []
            }
            list.map((key) => {
              that.uploadFileLists(result.data, key, item)
            })
          },
          onFail: function(err) {
            console.log(err, '0000')
            // alert('数据 ' + JSON.stringify(err))
          }
        }).then((res) => {
          console.log('then______err', res)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        }).catch((err) => {
          console.log('catch______err', err)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 上传文件接口
    uploadFileLists(type, key, item) {
      var date1 = {}
      // 添加文件
      if (!type) {
        date1 = {
          objectType: '1',
          objectId: '',
          type: '15',
          source: 'ding',
          absoUrl: key,
          taskId: '',
          proId: this.proId
        }
      } else {
        date1 = {
          objectType: '1',
          objectId: '',
          type: '15',
          taskId: '',
          proId: this.proId,
          source: 'ding',
          fileFormat: key.fileType,
          fileName: key.fileName,
          dingSpaceId: key.spaceId,
          dingFileId: key.fileId,
          fileSize: key.fileSize
        }
      }
      addDingFile(date1).then((res) => {
        if (res.code === 10000) {
          if (item.files) {
            item.files.push(res.result)
          } else {
            item.fileList.push(res.result)
          }
          this.addFormData()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '网络错误，请稍候！'
        })
      })
    },
    // 预览文件
    previewFile(item) {
      var date1 = {
        fileId: item.id
      }
      getShowAuthority(date1).then((data1) => {
        if (data1.coded === 10000) {
          var date = {
            fileIds: item.dingFileId
          }
          if (item?.source === 'ding') {
            initPreviewAuth(date).then((data) => {
              if (data.code === 10000) {
                preview({
                  corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
                  spaceId: item.dingSpaceId,
                  fileId: item.dingFileId,
                  fileName: item.fileName,
                  fileSize: item.fileSize,
                  fileType: item.fileFormat,
                  onSuccess: function(res) {
                  },
                  onFail: function(err) {
                    console.log(err)
                  // alert('数据 ' + JSON.stringify(err))
                  }
                })
              }
            }).catch((error) => {
              console.log(error)
            //  this.$message.error('网络错误，请稍候！')
            })
          } else {
            var imgs = ['MP4', 'AVI', 'WMV', 'MKV', 'FLV', 'MPG', 'MPEG', 'M2V', 'M3U8', 'TS', 'MOV', 'WMV', 'RM', 'RMVB', 'ASF', 'VOB', 'DAT', 'DV', 'M4V', 'WEBM', 'OGG', '3GP', 'MPEG4',
              'mp4', 'avi', 'wmv', 'mkv', 'flv', 'mpg', 'mpeg', 'm2v', 'm3u8', 'ts', 'mov', 'wmv', 'rm', 'rmvb', 'asf', 'vob', 'dat', 'dv', 'm4v', 'webm', 'ogg', '3gp', 'mpeg'
            ]
            if (imgs.includes(item.fileFormat)) {
              this.showVideo = true
              this.videoUrl = item.absoUrl
            } else {
              wpsOfficeConfig(item)
            }
          }
        } else {
          this.$message.warning(data1.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 删除文件01
    delFunFile(file, index, item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.files.splice(index, 1)
        this.$forceUpdate() // 强制更新视图
        // this.formList[index].files = res
        this.addFormData()
        // this.$message.success('文件删除成功！')
      })
    },
    // 删除文件
    delFun(file, index, item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: file.id
        }
        delFile(date).then((data) => {
          if (data.code === 10000) {
            item.fileList.splice(index, 1)
            item.files.splice(index, 1)
            this.$forceUpdate() // 强制更新视图
            // this.formList[index].files = res
            this.addFormData()
            // this.$message.success('文件删除成功！')
          }
        }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 富文本
    addDescs(result, index) {
      this.formList[index].describes.descList = result
      this.addFormData()
    },
    // 多选
    checkboxChange() {
      // this.$forceUpdate() // 强制更新视图
      this.addFormData()
    },
    // 多选1
    checkboxChange1(index, strArray) {
      this.formList[index].fieldValue = strArray.toString()
      this.addFormData()
    },
    // 表单传参
    addFormData() {
      if (this.formList) {
        this.formList.map((item) => {
          if (item.formField) {
            this.$emit('addForm', this.formList, this.dialogCreat, this.describes, 'process')
          } else {
            this.$emit('addForm', this.formList, this.dialogCreat, this.describes, '')
          }
        })
      }
    },
    editTaskChange() {
      this.addFormData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.info {
  width: 100% !important;
}
.form_fieldName {
  max-width: calc(100% - 40px);
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.info_personnel1 {
  /* // width: 65px; */
  font-size: $font_12;
  font-family: $font_family;
  font-weight: 400;
  color: $color_4;
  padding: 4px 15px 4px 10px;
  line-height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.uploadfile{
  height: 34px;
  line-height: 34px;
  color: #A8A8A8;
  display: inline-block;
  cursor: pointer;
}
.uploadfile:hover{
  color: $color_main;
}
.file_lists {
  width: 100%;
  padding-bottom: 5px;
  font-size: $font_12;
  font-family: $font_family;
  font-weight: 400;
  color: #909090;
  line-height: 24px;
  .file_boxs {
    width: calc(100% - 10px);
    padding: 4px 5px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .file_boxs:hover{
    background: rgba(40, 120, 255, 0.1);
  }
}
.icon-bianzu:hover {
  color: $color_main;
}

::v-deep .el-radio {
  line-height: 2.5 !important;
}
::v-deep .el-checkbox-group {
  line-height: 30px;
}
.pop_item{
  padding: 5px;
  cursor: pointer;
}
.pop_table{
      width: 85% !important;
    /* display: flex !important;
    justify-content: space-between !important;
    align-items: flex-start !important;
    flex-wrap: wrap !important;*/
    font-size: 14px !important;
    font-family: PingFang SC, sans-serif, Microsoft Yahei, 微软雅黑, Lucida Grande, Lucida Sans Unicode, Helvetica, Arial, Verdana !important;
    font-weight: 400;
    color: #202020;
    height: auto;
    ::v-deep .el-table--border .el-table__cell{
      border-right: 1px solid #EBEEF5 !important;
}
::v-deep .el-table--scrollable-y .el-table__body-wrapper {
  height: auto !important;
}
::v-deep .el-table .cell {
  height: auto !important;
  line-height: normal !important;
  padding: 10px !important;
  box-sizing: border-box;
}
// 确保表格行高度一致
::v-deep .el-table__row {
  height: 96px;  // 设置统一的行高
  line-height: 96px;
}

// 确保单元格内容垂直居中
::v-deep .el-table__cell {
  padding: 8px 0;
  .cell {
    line-height: 24px;
    display: flex;
    align-items: center;
  }
}
::v-deep .el-textarea__inner{
    min-height: 33px;
    height: 96px !important;
}
}
</style>
